import * as dayjs from 'dayjs';
import { VersionRange } from '../../models/core/version-range.js';
import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';
import { TimeZone } from '../../time/timezone.js';

export class GateOpenTimeComponent extends Component {
  static readonly TYPE_ID: string = 'ff9e73a42c0b47cd91dd5537261763a2';
  static readonly SCHEMA_VERSION: number = 1;

  constructor(
    public readonly openTime: dayjs.Dayjs,
  ) {
    super();
  }

  get $typeId() {
    return GateOpenTimeComponent.TYPE_ID;
  }

  get $schemaVersion(): VersionRange {
    return VersionRange.exactly(GateOpenTimeComponent.SCHEMA_VERSION);
  }

  get $removable(): boolean {
    return true;
  }

  static fromMap(context: SerializationContext, map: SerializedData): GateOpenTimeComponent {
    return new GateOpenTimeComponent(
        context.decodeDate(MapUtils.get<number>(map, 'openTime')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'openTime': context.encodeDate(this.openTime),
    };
  }

  clone(): this {
    return new GateOpenTimeComponent(
        TimeZone.cloneDate(this.openTime),
    ) as this;
  }

  isSame(other: GateOpenTimeComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.openTime === this.openTime;
  }
}

export class GateOpenTimeComponentBuilder extends DataModelBuilder<GateOpenTimeComponent> {
  build(context: SerializationContext, map: SerializedData): GateOpenTimeComponent {
    return GateOpenTimeComponent.fromMap(context, map);
  }
}
